module.exports = __webpack_public_path__ + "Tinebase/js/ace-mode-csound_orchestra-FAT.js";